/*******************************************************************************
  Routes.js

  Author: Advait

  This file is responsible for router implementation
*******************************************************************************/
import React from "react";
import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";
import Home from "./Home";
import SystemConfig from "./SystemConfig";
import SiteInspectionConfig from "./SiteInspectionConfig";
import ReceptionistConfig from "./ReceptionistConfig";
import SecurityConfig from "./SecurityConfig";
import Reporting from "./Reporting";
import Insights from "./Insights";
import CreateSite from "./CreateSite";
import ManageTenants from "./ManageTenants";
import Users from "./Users";
import UpcomingSessions from "./UpcomingSessions";
import DevPage from "./DevPage";
import logo from "../assets/img/logo-ava.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "../index.css";

function Routes(props) {
  return (
    <Router>
      <div style={{ display: "flex", overflowX: "auto", minWidth: "210px + 515px" }}>
        <div className="sidebar">
          <div className="sidebar-logo-img">
            <a href="/">
              <img src={logo} alt="logo_image" />
            </a>
          </div>
          <div
            style={{ width: "100%", padding: "25px", marginTop: "65px", overflowY: "auto" }}
          >
            <NavLink to="/" exact activeClassName="current">
              Home
            </NavLink>
            <NavLink to="/insights" exact activeClassName="current">
              <hr />
              Insights{" "}
            </NavLink>
            <hr />
            <NavLink to="/reporting" exact activeClassName="current">
              Reporting{" "}
            </NavLink>
            <hr />
            <NavLink to="/systemconfig" exact activeClassName="current">
              System Config
            </NavLink>
            <hr />
            <NavLink to="/siteinspectionconfig" exact activeClassName="current">
              {" "}
              Inspection Config{" "}
            </NavLink>
            <hr />
            <NavLink to="/sitesecuritypatrolconfig" exact activeClassName="current">
              {" "}
              Security Patrol Config{" "}
            </NavLink>
            <hr />
            <NavLink to="/receptionistconfig" exact activeClassName="current">
              Receptionist Config{" "}
            </NavLink>
            {props.user.sysadmin ? (
              <NavLink to="/managetenants" exact activeClassName="current">
                <hr />
                Manage Tenants{" "}
              </NavLink>
            ) : null}
            {props.user.sysadmin ? (
              <NavLink to="/managesites" exact activeClassName="current">
                <hr />
                Manage Sites{" "}
              </NavLink>
            ) : null}
            {props.user.sysadmin ? (
              <NavLink to="/users" exact activeClassName="current">
                <hr />
                Manage Users{" "}
              </NavLink>
            ) : null}
            {props.user.sysadmin ? (
              <NavLink to="/UpcomingSessions" exact activeClassName="current">
                <hr />
                Upcoming Sessions{" "}
              </NavLink>
            ) : null}
            {props.user.sysadmin ? (
              <NavLink to="/devpage" exact activeClassName="current">
                <hr />
                Dev Page{" "}
              </NavLink>
            ) : null}
          </div>
        </div>
        <div className="mainWindow">
          <Route path="/" exact component={() => <Home sysadmin={props.user.sysadmin} />} />
          <Route path="/systemconfig" component={SystemConfig} />
          <Route path="/siteinspectionconfig" component={SiteInspectionConfig} />
          <Route path="/sitesecuritypatrolconfig" component={SecurityConfig} />
          <Route path="/receptionistconfig" component={ReceptionistConfig} />
          <Route path="/reporting" component={Reporting} />
          <Route path="/insights" component={Insights} />
          {props.user.sysadmin ? (
            <Route path="/managetenants" component={ManageTenants} />
          ) : null}
          {props.user.sysadmin ? <Route path="/managesites" component={CreateSite} /> : null}
          {props.user.sysadmin ? <Route path="/users" component={Users} /> : null}
          {props.user.sysadmin ? (
            <Route path="/UpcomingSessions" component={UpcomingSessions} />
          ) : null}
          {
            /* NOTE:
            Following <Route path="/devpage" component={DevPage}/> is purely for
            development purpose. Please remove it before realising the application.*/
            props.user.sysadmin ? <Route path="/devpage" component={DevPage} /> : null
          }
        </div>
      </div>
    </Router>
  );
}
export default Routes;
